<template>
  <div>
    <ToolbarAuth />
    <div v-if="loading">
      <loading />
    </div>
    <div class="mt-15 ml-15 mr-15">
      <v-btn large color="info" class="mb-10" @click="goNew">Maak nieuw</v-btn>
      <v-row>
        <v-col cols="12">
          <v-card elevation="15">
            <v-card-title class="primary--text"
            >Noodplan BV
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="mdi-magnify" v-bind:label="$t('crud.search')" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="bv_plans"
                :search="search"
                :loading="loading"
                v-bind:loading-text="$t('crud.loading')"
                :footer-props="{ 'items-per-page-options': [15, 30, 50, 100, -1], itemsPerPageText: $t('crud.nr') }"
              >
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="viewItem(item.id)" class="mr-2 accent--text" v-bind="attrs" v-on="on"> mdi-magnify </v-icon>
                    </template>
                    <span class="text-uppercase">Bekijk</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="mr-2 secondary--text" @click="editItem(item.id)" v-bind="attrs" v-on="on"> mdi-pencil </v-icon>
                    </template>
                    <span class="text-uppercase"> Wijzig</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="mr-2 info--text" @click="goMail(item.id)" v-bind="attrs" v-on="on"> mdi-mail </v-icon>
                    </template>
                    <span class="text-uppercase"> Nodig uit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="mr-2 info--text" @click="goModules(item.id)" v-bind="attrs" v-on="on"> mdi-view-module </v-icon>
                    </template>
                    <span class="text-uppercase"> Modules</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="mr-2 info--text" @click="goReports(item.id)" v-bind="attrs" v-on="on"> mdi-file-chart </v-icon>
                    </template>
                    <span class="text-uppercase">Rapporten</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="showDeleteDialog(item)" class="mr-2 primary--text" v-bind="attrs" v-on="on"> mdi-delete </v-icon>
                    </template>
                    <span class="text-uppercase"> {{ $t("crud.delete") }}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title>{{ $t("crud.delete") }}</v-card-title>
                  <v-card-text>
                    {{ $t("crud.select") }}: `{{ itemToDelete.first_name_client }} {{ itemToDelete.last_name_client }} ` <br />
                    <br />{{ $t("crud.rys") }} <br />
                    {{ $t("crud.irr") }}</v-card-text
                  >
                  <v-card-actions>
                    <v-btn color="primary" text @click="dialogDelete = false">{{ $t("crud.close") }}</v-btn>
                    <v-btn color="primary" text @click="deleteItem()">{{ $t("crud.delete") }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import { mapGetters } from "vuex";
import { getError } from "@/utils/helpers";
import Loading from "@/components/loading";
import NplanBvService from "@/services/nplan/NplanBvService";

export default {
  name: "Clients",
  components: { Loading, ToolbarAuth },
  data() {
    return {
      error: null,
      dialogDelete: false,
      itemToDelete: {},
      email: "",
      search: "",
      headers: [
        {
          text: "id",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: this.$t("users.first_name"),
          align: "start",
          sortable: true,
          value: "first_name_client",
        },
        {
          text: this.$t("users.last_name"),
          align: "start",
          sortable: true,
          value: "last_name_client",
        },
        {
          text: "Bedrijfsnaam",
          align: "start",
          sortable: true,
          value: "name_company",
        },
        {
          text: "Relatiemanager",
          align: "start",
          sortable: false,
          value: "user.full_name",
        },
        { text: this.$t("crud.actions"), value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    goNew() {
      this.$router.push({ name: "bvCreate" });
    },
    showDeleteDialog(item) {
      this.itemToDelete = item;
      this.dialogDelete = !this.dialogDelete;
    },
    viewItem(id) {
      this.$router.push({ name: "bvView", params: { id: id } });
    },
    editItem(id) {
      this.$router.push({ name: "bvEdit", params: { id: id } });
    },
    goModules(id) {
      this.$router.push({ name: "bvModules", params: { id: id } });
    },
    goReports(id) {
      this.$router.push({ name: "bvReports", params: { id: id } });
    },
    goMail(id) {
      this.$router.push({ name: "bvMail", params: { id: id } });
    },
    deleteItem() {
      console.log("deleteItem", this.itemToDelete);
      let id = this.itemToDelete.id;
      this.error = null;
      NplanBvService.deleteMain(id)
        .then(() => {
          this.$store.dispatch("bv/getBVplans");
          this.dialog = false;
        })
        .catch((error) => (this.error = getError(error)));

      this.dialogDelete = false;
    },


  },



  computed: {
    ...mapGetters("bv", ["loading", "bv_plans"]),
  },
  created() {
    this.$store.dispatch("bv/getBVplans");
  },
};
</script>

<style scoped></style>
